import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { NoDataCardStyles } from "./NoDataCard.styles";
export var NoDataCard = function (_a) {
    var label = _a.label;
    var sx = NoDataCardStyles();
    return _jsx(Box, { sx: sx.wrapper, children: label });
};
